import React from 'react'

import { Container, From, On } from 'components/RoutePath/style'

import { Link } from 'react-router-dom'

const RoutePath = ({ path, from, on, fromArr = [] }) => {
  return (
    <Container centerVertically>
      {fromArr?.length > 0 ? (
        fromArr?.map((item, index) => (
          <Container key={index + item?.from + 'routing'}>
            <Link to={item?.path}>
              <From>{item?.from}</From>
            </Link>
            <On>/</On>
          </Container>
        ))
      ) : (
        <>
          <Link to={path}>
            <From>{from}</From>
          </Link>
          {on && <On>/</On>}
        </>
      )}
      {on && <On>{on}</On>}
    </Container>
  )
}

export default RoutePath
